(function($) {
  $('.stone-detail-slider').slick({
    autoplay: true,
    pauseOnHover: true,
    infinite: true,
    variableWidth: true,
    swipeToSlide: true,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          variableWidth: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
        // settings: "unslick"
      },
    ]
  });
})($);